import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../i18n/components/T.js'
import { ChartTimeFrame } from '../types/index.js'
import { analyticsNumberFormatter } from '../utils/parser.js'

interface Props {
  total: number | string
  current: number | string
  timeFrame: ChartTimeFrame
  isLoading: boolean
}

export const AllTimeScore = ({
  total,
  current,
  timeFrame,
  isLoading,
}: Props) => {
  return (
    <div className={isLoading ? 'opacity-30' : ''}>
      <div className="flex flex-col space-y-1">
        <div className="text-heading-sm text-content">
          {isLoading ? '-' : analyticsNumberFormatter(total)}
        </div>
        <div className="h-3 flex items-center text-xs">
          {!isLoading ? (
            <>
              <SvgIcon
                className="w-3 text-content-on-positive"
                name="arrow-up"
              />
              <span className="text-content-on-positive">
                {analyticsNumberFormatter(current)}&nbsp;
              </span>
              <span className="text-content-subdued">
                <T
                  id="Analytics.AllTimeScore.InTimeFrame"
                  defaultMessage="in {time_frame_text}"
                  values={{
                    time_frame_text: timeFrame.text.toLocaleLowerCase(),
                  }}
                />
              </span>
            </>
          ) : (
            ' '
          )}
        </div>
      </div>
    </div>
  )
}
